module.exports = new __parcel__URL__("righteouscleansing.4d096e4d.png").toString();